import { Injectable } from '@angular/core';
import { AuthorizationCodeRequestService } from './authorization-code-request.service';
import { AuthModule } from '../auth.module';
import { AuthorityService } from '../authority/authority.service';

@Injectable({
  providedIn: AuthModule
})
export class AuthorizationCodeExchangeService {
  get path() {
    return this.authorizationCodeRequestService.path;
  }
  constructor(private authorizationCodeRequestService: AuthorizationCodeRequestService,
    private authorityService: AuthorityService) { }

  run(authorizationCode) {
    return this.authorityService.post(this.path, this.createBody(authorizationCode), this.createOptions());
  }

  createOptions() {
    return this.authorizationCodeRequestService.createOptions();
  }

  createBody(code) {
    return this.authorizationCodeRequestService.createBody(code);
  }
}
